import React, { useEffect } from 'react'
import { ArrayField } from 'react-hook-form'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import { CalendarIcon } from 'transfix-icons/build'
import { Grid, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { SHIPMENT_EVENT_OPERATOR_OPTIONS, SHIPMENT_EVENT_FIELD_OPTIONS } from '../constants'
import { useIssueRuleFormContext, getErrorMessage, TIssueRuleFormFormSchema } from './RuleForm'
import TriggerCard from './TriggerCard'

const useStyles = makeStyles(() => ({
  selectOperator: {
    '& legend': {
      color: brandColors.coolGray5,
    },
  },
}))

interface IShipmentEventCardProps {
  onAddTrigger: () => void
  isAddTriggerDisabled: boolean
  onRemove: () => void
  showClearButton: boolean
  onCancel: () => void
  index: number
  node: Partial<ArrayField<TIssueRuleFormFormSchema['nodes'][number], 'key'>>
}

function ShipmentEventCard({
  index,
  isAddTriggerDisabled,
  node,
  onAddTrigger,
  onCancel,
  onRemove,
  showClearButton,
}: IShipmentEventCardProps) {
  const classes = useStyles()
  const { control, errors, setValue } = useIssueRuleFormContext()

  const operatorOptionsLength = SHIPMENT_EVENT_OPERATOR_OPTIONS.length
  const fieldOptionsLength = SHIPMENT_EVENT_FIELD_OPTIONS.length

  // Auto selects shipmentEventOperator and shipmentEventField fields if there is only one option for the respective field
  useEffect(() => {
    if (operatorOptionsLength === 1) {
      // If there is only one option available, select it
      setValue(`nodes[${index}].shipmentEventOperator`, SHIPMENT_EVENT_OPERATOR_OPTIONS[0].value)
    }
    if (fieldOptionsLength === 1) {
      // If there is only one option available, select it
      setValue(`nodes[${index}].shipmentEventField`, SHIPMENT_EVENT_FIELD_OPTIONS[0].value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorOptionsLength, fieldOptionsLength])

  return (
    <TriggerCard
      icon={<CalendarIcon className='inline' size='xlarge' color='skyBlue6' />}
      isAddTriggerDisabled={isAddTriggerDisabled}
      onAddTrigger={onAddTrigger}
      onCancel={onCancel}
      onRemove={onRemove}
      showClearButton={showClearButton}
      title='Shipment Event'>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={5}>
          <ControlledSelect
            control={control}
            name={`nodes[${index}].shipmentEventOperator`}
            defaultValue={node.shipmentEventOperator}
            SelectProps={{
              options: SHIPMENT_EVENT_OPERATOR_OPTIONS,
              error: !!getErrorMessage(errors, `nodes[${index}].shipmentEventOperator`),
              validationMessage: getErrorMessage(errors, `nodes[${index}].shipmentEventOperator`),
              disabled: operatorOptionsLength === 1,
            }}
          />
        </Grid>
        <Grid item xs={12} lg={12} className={classes.selectOperator}>
          <ControlledSelect
            control={control}
            name={`nodes[${index}].shipmentEventField`}
            defaultValue={node.shipmentEventField}
            SelectProps={{
              options: SHIPMENT_EVENT_FIELD_OPTIONS,
              error: !!getErrorMessage(errors, `nodes[${index}].shipmentEventField`),
              validationMessage: getErrorMessage(errors, `nodes[${index}].shipmentEventField`),
            }}
          />
        </Grid>
      </Grid>
    </TriggerCard>
  )
}

export default ShipmentEventCard
